<template>
  <div>
    <FilterOverview title="Zahlläufe" :showFilterInitially="false">
      <template #table="{ tableHeight }">
        <b-overlay :show="isLoading">
          <div
            class="p-6 card card-body"
            style="min-width: 900px; overflow: auto"
            :style="{ height: tableHeight + 87 + 'px' }"
          >
            <div class="mb-4 filter-field" style="max-width: 312px">
              <AppSelect
                v-model="selectedKreditoren"
                apply-mode="button"
                :options="countryManagerOptions"
                label="Kreditoren"
                multiple
                placeholder="Kreditoren filtern..."
                no-results-text="Kein Kreditor gefunden."
              />
            </div>
            <div
              v-for="countryManager in filteredCountryManagers"
              :key="countryManager.countryManagerKuerzel"
              class="mt-4 d-flex"
              style="gap: 12px"
            >
              <b-form-group label="Kreditor">
                <h6 class="mb-0" style="width: 150px">{{ countryManager.countryManagerKuerzel }}</h6>
              </b-form-group>

              <b-form-group label="Zahllauf">
                <b-form-input
                  v-model="countryManager.zahllauf"
                  @update="changeZahllauf(countryManager.zahllauf, countryManager.countryManagerKuerzel)"
                  debounce="500"
                  type="text"
                  style="width: 150px"
                />
              </b-form-group>
            </div>
          </div>
        </b-overlay>
      </template>
    </FilterOverview>
  </div>
</template>

<script>
import FilterOverview from '@/components/common/filter-overview.vue';
import apiService from '@/core/common/services/api.service';
import AppSelect from '@/components/common/app-select/app-select.vue';

export default {
  components: {
    FilterOverview,
    AppSelect,
  },
  data() {
    return {
      countryManagers: [],
      selectedKreditoren: [],
      isLoading: false,
    };
  },
  computed: {
    countryManagerOptions() {
      return this.countryManagers.map(cm => cm.countryManagerKuerzel).sort();
    },
    filteredCountryManagers() {
      if (!this.selectedKreditoren || this.selectedKreditoren.length === 0) {
        return this.countryManagers;
      }
      return this.countryManagers.filter(cm => this.selectedKreditoren.includes(cm.countryManagerKuerzel));
    },
  },
  mounted() {
    this.loadCountryManagers();
  },
  methods: {
    loadCountryManagers() {
      this.isLoading = true;
      apiService
        .get('/CountryManager')
        .then(result => {
          this.countryManagers = result.data.result.value.filter(
            cm => !cm.countryManagerKuerzel.startsWith('0')
          );
        })
        .finally(() => (this.isLoading = false));
    },
    changeZahllauf(zahllauf, countryManagerKuerzel) {
      this.isLoading = true;
      apiService
        .put('/CountryManager/updateZahllauf', { countryManagerKuerzel, zahllauf })
        .then(() => {
          this.loadCountryManagers();
          this.toast(`Zahllauf des Countrymanager: ${countryManagerKuerzel} erfolgreich geändert.`);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>

<style scoped>
.filter-field {
  --app-select-border-color: #e4e6ef;
}
</style>
